/**
 * Tiny structured logger for the browser console. Every line is prefixed with
 * [MightyPeanut] so it is easy to filter in DevTools (F12 → Console).
 */
type Level = 'debug' | 'info' | 'warn' | 'error';

function write(level: Level, event: string, data?: Record<string, unknown>): void {
  const line: string = `[MightyPeanut] ${event}`;
  const payload: Record<string, unknown> = data ?? {};
  switch (level) {
    case 'debug': console.debug(line, payload); break;
    case 'info': console.info(line, payload); break;
    case 'warn': console.warn(line, payload); break;
    case 'error': console.error(line, payload); break;
  }
}

export const log = {
  debug: (event: string, data?: Record<string, unknown>): void => write('debug', event, data),
  info: (event: string, data?: Record<string, unknown>): void => write('info', event, data),
  warn: (event: string, data?: Record<string, unknown>): void => write('warn', event, data),
  error: (event: string, data?: Record<string, unknown>): void => write('error', event, data),
};

/** Turns anything thrown into a readable message for the UI. */
export function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  if (err && typeof err === 'object' && 'message' in err && typeof (err as { message: unknown }).message === 'string') {
    return (err as { message: string }).message;
  }
  return 'Something went wrong.';
}
